<template>
  <div class="app-main-inner-page">
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('SeaExport.AntiTerroristFormattedAddress')"
      width="840px"
      :close-on-click-modal="false"
      class="app-main-inner edi-address-format-dialog"
      :append-to-body="true"
    >
      <div class="app-main-inner-row">
        <cargo-left-right-resize
          style="width: 100%;"
          :show-left="showGrid"
          :left-style="{width: '16%'}"
          :right-style="{width: showGrid ? '74%' : '90%'}"
        >
          <div slot="left" class="app-main-inner-row row-grid" style="padding: 0; height:460px;">

            <cargo-ag-grid
              :show-side-bar="false"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="rowData"
              style="width:100%;"
            />
          </div>
          <div slot="right" style="height: 460px;">
            <el-scrollbar style="height:100%;width:auto;" :native="true">
              <el-form :inline="true" label-width="40px" label-position="left" style="width: 640px;">
                <div class="el-form-item-wrapper" style="padding-left: 116px;">
                  <el-form-item>
                    <el-checkbox v-model="addressForm.consolidationClosed" no="1" :true-label="1" false-label="0">{{ $t('SeaExport.LCLLastBillOfLading') }}</el-checkbox>
                  </el-form-item>
                </div>
                <div class="el-form-item-wrapper">
                  <div class="app-main-inner-row form-item-border-group">
                    <div class="form-item-group-label">
                      <span>{{ $t('CargoMsg.Cargo_Shipper') }}</span>
                    </div>
                    <div>
                      <el-form-item :label="$t('Tool.Name')" class="form-item-long">
                        <el-input v-model="addressForm.shipperLine1" no="2" />
                        <el-input v-model="addressForm.shipperLine2" no="3" />
                      </el-form-item>
                      <el-form-item :label="$t('SeaExport.Addr')" class="form-item-long">
                        <el-input v-model="addressForm.shipperLine3" no="4" />
                        <el-input v-model="addressForm.shipperLine4" no="5" />
                        <el-input v-model="addressForm.shipperLine5" no="6" />
                      </el-form-item>
                      <el-form-item :label="$t('CargoMsg.Cargo_Country')">
                        <el-input v-model="addressForm.shipperCountry" no="7" :maxlength="2" />
                      </el-form-item>
                      <el-form-item :label="$t('SeaExport.Province')">
                        <el-input v-model="addressForm.shipperProvince" no="8" />
                      </el-form-item>
                      <el-form-item :label="$t('CargoMsg.Cargo_CityP')">
                        <el-input v-model="addressForm.shipperCity" no="9" />
                      </el-form-item>
                      <el-form-item :label="$t('SeaExport.ZIP')">
                        <el-input v-model="addressForm.shipperPostalcode" no="10" />
                      </el-form-item>
                      <el-form-item :label="$t('CargoMsg.Cargo_Tel')">
                        <el-input v-model="addressForm.shipperTel" no="11" />
                      </el-form-item>
                      <el-form-item :label="$t('CargoMsg.Cargo_Fax')">
                        <el-input v-model="addressForm.shipperFax" no="12" />
                      </el-form-item>
                    </div>
                  </div>
                </div>
                <div class="el-form-item-wrapper">
                  <div class="app-main-inner-row form-item-border-group">
                    <div class="form-item-group-label">
                      <span>{{ $t('CargoMsg.Cargo_Consignee') }}</span>
                    </div>
                    <div>
                      <el-form-item :label="$t('Tool.Name')" class="form-item-long">
                        <el-input v-model="addressForm.consigneeLine1" no="13" />
                        <el-input v-model="addressForm.consigneeLine2" no="14" />
                      </el-form-item>
                      <el-form-item :label="$t('SeaExport.Addr')" class="form-item-long">
                        <el-input v-model="addressForm.consigneeLine3" no="15" />
                        <el-input v-model="addressForm.consigneeLine4" no="16" />
                        <el-input v-model="addressForm.consigneeLine5" no="17" />
                      </el-form-item>
                      <el-form-item :label="$t('CargoMsg.Cargo_Country')">
                        <el-input v-model="addressForm.consigneeCountry" no="18" :maxlength="2" />
                      </el-form-item>
                      <el-form-item :label="$t('SeaExport.Province')">
                        <el-input v-model="addressForm.consigneeProvince" no="19" />
                      </el-form-item>
                      <el-form-item :label="$t('CargoMsg.Cargo_CityP')">
                        <el-input v-model="addressForm.consigneeCity" no="20" />
                      </el-form-item>
                      <el-form-item :label="$t('SeaExport.ZIP')">
                        <el-input v-model="addressForm.consigneePostalcode" no="21" />
                      </el-form-item>
                      <el-form-item :label="$t('CargoMsg.Cargo_Tel')">
                        <el-input v-model="addressForm.consigneeTel" no="22" />
                      </el-form-item>
                      <el-form-item :label="$t('CargoMsg.Cargo_Fax')">
                        <el-input v-model="addressForm.consigneeFax" no="23" />
                      </el-form-item>
                    </div>
                  </div>
                </div>
                <div class="el-form-item-wrapper">
                  <div class="app-main-inner-row form-item-border-group">
                    <div class="form-item-group-label">
                      <span>{{ $t('CargoMsg.Cargo_NotifyParty') }}</span>
                    </div>
                    <div>
                      <el-form-item :label="$t('Tool.Name')" class="form-item-long">
                        <el-input v-model="addressForm.notifyLine1" no="24" />
                        <el-input v-model="addressForm.notifyLine2" no="25" />
                      </el-form-item>
                      <el-form-item :label="$t('SeaExport.Addr')" class="form-item-long">
                        <el-input v-model="addressForm.notifyLine3" no="26" />
                        <el-input v-model="addressForm.notifyLine4" no="27" />
                        <el-input v-model="addressForm.notifyLine5" no="28" />
                      </el-form-item>
                      <el-form-item :label="$t('CargoMsg.Cargo_Country')">
                        <el-input v-model="addressForm.notifyCountry" no="29" :maxlength="2" />
                      </el-form-item>
                      <el-form-item :label="$t('SeaExport.Province')">
                        <el-input v-model="addressForm.notifyProvince" no="30" />
                      </el-form-item>
                      <el-form-item :label="$t('CargoMsg.Cargo_CityP')">
                        <el-input v-model="addressForm.notifyCity" no="31" />
                      </el-form-item>
                      <el-form-item :label="$t('SeaExport.ZIP')">
                        <el-input v-model="addressForm.notifyPostalcode" no="32" />
                      </el-form-item>
                      <el-form-item :label="$t('CargoMsg.Cargo_Tel')">
                        <el-input v-model="addressForm.notifyTel" no="33" />
                      </el-form-item>
                      <el-form-item :label="$t('CargoMsg.Cargo_Fax')">
                        <el-input v-model="addressForm.notifyFax" no="34" />
                      </el-form-item>
                    </div>
                  </div>
                </div>
                <div class="el-form-item-wrapper">
                  <div class="app-main-inner-row form-item-border-group">
                    <div class="form-item-group-label">
                      <span>{{ $t('CargoMsg.Cargo_SecondNotifyParty') }}</span>
                    </div>
                    <div>
                      <el-form-item :label="$t('Tool.Name')" class="form-item-long">
                        <el-input v-model="addressForm.alsonotifyLine1" no="35" />
                        <el-input v-model="addressForm.alsonotifyLine2" no="36" />
                      </el-form-item>
                      <el-form-item :label="$t('SeaExport.Addr')" class="form-item-long">
                        <el-input v-model="addressForm.alsonotifyLine3" no="37" />
                        <el-input v-model="addressForm.alsonotifyLine4" no="38" />
                        <el-input v-model="addressForm.alsonotifyLine5" no="39" />
                      </el-form-item>
                      <el-form-item :label="$t('CargoMsg.Cargo_Country')">
                        <el-input v-model="addressForm.alsonotifyCountry" no="40" :maxlength="2" />
                      </el-form-item>
                      <el-form-item :label="$t('SeaExport.Province')">
                        <el-input v-model="addressForm.alsonotifyProvince" no="41" />
                      </el-form-item>
                      <el-form-item :label="$t('CargoMsg.Cargo_CityP')">
                        <el-input v-model="addressForm.alsonotifyCity" no="42" />
                      </el-form-item>
                      <el-form-item :label="$t('SeaExport.ZIP')">
                        <el-input v-model="addressForm.alsonotifyPostalcode" no="43" />
                      </el-form-item>
                      <el-form-item :label="$t('CargoMsg.Cargo_Tel')">
                        <el-input v-model="addressForm.alsonotifyTel" no="44" />
                      </el-form-item>
                      <el-form-item :label="$t('CargoMsg.Cargo_Fax')">
                        <el-input v-model="addressForm.alsonotifyFax" no="45" />
                      </el-form-item>
                    </div>
                  </div>
                </div>
              </el-form>
            </el-scrollbar>
          </div>
        </cargo-left-right-resize>
      </div>
      <div slot="footer">
        <div style="display: inline-block; position: absolute; left: 0; padding-left: 10px;">
          <el-button no="46" type="primary" @click="copyLatest">{{ $t('SeaExport.CopyFromTheLastTime') }}</el-button>
          <el-button no="47" type="primary" @click="copyHawb">HAWB{{ $t('SeaExport.CopyTheDataBy') }}</el-button>
        </div>
        <div style="display: inline-block;">
          <el-button no="48" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
          <el-button no="49" @click="innerVisible=false">{{ $t('common.btn.close') }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import { getGridSelected } from '@/utils/agGrid'
import { localCacheDatas } from '@/utils/cacheConfig'
import { getJobByUuid } from '@/api/booking/job'
import Cookies from 'js-cookie'
import { getLoading } from '@/utils/utilBaseElement'
import { cacheName, cache } from '@/utils/cacheManager'
import { Job } from '@/class/model/booking/Job'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import { AfrAddress } from '@/class/model/booking/AfrAddress'
import ColumnUtils from '@/utils/ColumnUtils'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'

export default {
  name: 'AeAddressFormatDialog',
  components: { cargoLeftRightResize },
  props: {
    visible: { type: Boolean, required: true },
    showGrid: { type: Boolean, default: false },
    job: { type: Object, default: null },
    params: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: false,
      cargoDoc: null,
      addressForm: new AfrAddress().fillDefaultValue().getData(),
      // 上次地址详情（用于抄录上次，保存时记录地址详情）
      addressHistory: {},
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        onRowClicked: this.changeSelectRow
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_BLNo'),
          field: 'hblNbr2',
          width: 180
        }
      ],
      rowData: [],
      lookup: {},
      cargoDocType: {
        MBL: 'MBL',
        MBL2: 'MBL2',
        HBL: 'HBL',
        HBL2: 'HBL2',
        AMS: 'AMS',
        MAWB: 'MAWB',
        HAWB: 'HAWB',
        HAWB2: 'HAWB2', // 形式分单
        AFR: 'AFR',
        MSC: 'MSC'
      }
    }
  },
  watch: {
    visible(newVal, oldVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal, oldVal) {
      if (newVal) {
        cache.load(cacheName.CONFIG)
        this.rowData = this.params.cargoDocs
        this.cargoDoc = this.rowData[0]
        new SeaCargoDoc(this.cargoDoc).getAfrAddress().then(data => {
          if (data[0]) {
            this.addressForm = { ...data[0] }
          } else {
            new AfrAddress(this.addressForm).reset()
            this.addressForm.cargoDocUuid = this.cargoDoc.uuid
          }
        })
      } else {
        new AfrAddress(this.addressForm).reset()
      }
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    changeSelectRow() {
      this.cargoDoc = getGridSelected(this.gridOptions)[0]
      new SeaCargoDoc(this.cargoDoc).getAfrAddress().then(data => {
        if (data[0]) {
          this.addressForm = { ...data[0] }
        } else {
          new AfrAddress(this.addressForm).reset()
          this.addressForm.cargoDocUuid = this.cargoDoc.uuid
        }
      })
    },
    // 抄录上次
    copyLatest() {
      // 从缓存取记录
      const afrAddress = Cookies.get('afrAddressHistory')
      if (afrAddress && afrAddress.trim().length > 0) {
        this.copyAfrHistoryDetail(JSON.parse(afrAddress))
      }
    },
    /**
     * 抄录上次
     */
    copyAfrHistoryDetail(history) {
      const addressForm = this.addressForm
      addressForm.shipperLine1 = history.shipperLine1
      addressForm.shipperLine2 = history.shipperLine2
      addressForm.shipperLine3 = history.shipperLine3
      addressForm.shipperLine4 = history.shipperLine4
      addressForm.shipperLine5 = history.shipperLine5
      addressForm.shipperTel = history.shipperTel
      addressForm.shipperFax = history.shipperFax
      addressForm.shipperCity = history.shipperCity
      addressForm.shipperProvince = history.shipperProvince
      addressForm.shipperCountry = history.shipperCountry
      addressForm.shipperPostalcode = history.shipperPostalcode

      addressForm.consigneeLine1 = history.consigneeLine1
      addressForm.consigneeLine2 = history.consigneeLine2
      addressForm.consigneeLine3 = history.consigneeLine3
      addressForm.consigneeLine4 = history.consigneeLine4
      addressForm.consigneeLine5 = history.consigneeLine5
      addressForm.consigneeTel = history.consigneeTel
      addressForm.consigneeFax = history.consigneeFax
      addressForm.consigneeCity = history.consigneeCity
      addressForm.consigneeProvince = history.consigneeProvince
      addressForm.consigneeCountry = history.consigneeCountry
      addressForm.consigneePostalcode = history.consigneePostalcode

      addressForm.notifyLine1 = history.notifyLine1
      addressForm.notifyLine2 = history.notifyLine2
      addressForm.notifyLine3 = history.notifyLine3
      addressForm.notifyLine4 = history.notifyLine4
      addressForm.notifyLine5 = history.notifyLine5
      addressForm.notifyTel = history.notifyTel
      addressForm.notifyFax = history.notifyFax
      addressForm.notifyCity = history.notifyCity
      addressForm.notifyProvince = history.notifyProvince
      addressForm.notifyCountry = history.notifyCountry
      addressForm.notifyPostalcode = history.notifyPostalcode

      addressForm.alsonotifyLine1 = history.alsonotifyLine1
      addressForm.alsonotifyLine2 = history.alsonotifyLine2
      addressForm.alsonotifyLine3 = history.alsonotifyLine3
      addressForm.alsonotifyLine4 = history.alsonotifyLine4
      addressForm.alsonotifyLine5 = history.alsonotifyLine5
      addressForm.alsonotifyTel = history.alsonotifyTel
      addressForm.alsonotifyFax = history.alsonotifyFax
      addressForm.alsonotifyCity = history.alsonotifyCity
      addressForm.alsonotifyProvince = history.alsonotifyProvince
      addressForm.alsonotifyCountry = history.alsonotifyCountry
      addressForm.alsonotifyPostalcode = history.alsonotifyPostalcode

      addressForm.consolidationClosed = history.consolidationClosed
    },
    // 抄录HAWB
    async copyHawb() {
      const airCargoDoc = await this.getCargoDoc(this.cargoDocType.HAWB, false)
      if (airCargoDoc) {
        this.copyDocDetail(airCargoDoc)
      }
    },
    async save() {
      const afrAddress = this.addressForm
      afrAddress.state = 0
      afrAddress.docType = this.cargoDocType.AFR
      // 保存到缓存中
      Cookies.set('afrAddressHistory', afrAddress)
      try {
        this.loading = getLoading()
        if (!afrAddress.cargoDocUuid) {
          await new SeaCargoDoc(this.cargoDoc).save().then(res => {
            this.assignIgnoreSubObject(this.cargoDoc, res.data)
          })
          afrAddress.cargoDocUuid = this.cargoDoc.uuid
        }
        await AfrAddress.save(afrAddress).then(data => {
          if (afrAddress.uuid) {
            this.assignIgnoreSubObject(this.rowData[0].afrAddress[0], data)
            this.addressForm = data
          } else {
            this.rowData[0].afrAddress.push(data)
            this.assignIgnoreSubObject(this.addressForm, data)
          }
        })
      } finally {
        this.loading.close()
      }
      await this.$confirm(this.$t('Message.SaveSuccessfully'), this.$t('CargoMsg.Cargo_Success'), {
        confirmButtonText: this.$t('common.btn.ok'),
        showCancelButton: false,
        showClose: false,
        closeOnClickModal: false,
        type: 'success'
      }).then(() => {
        this.innerVisible = false
      }).catch(() => { })
    },
    // 拷贝非对象属性
    assignIgnoreSubObject(target, source) {
      for (const key in source) {
        if (typeof target[key] === 'object') {
          continue
        }
        target[key] = source[key]
      }
    },
    // 检索单号弹窗选择地址信息后回调函数
    selectAddressInfo(data) {
      const hblDoc = data[0] || data
      if (hblDoc) {
        if (hblDoc.docType === 'AMS') {
          this.copyAfrDetail(hblDoc.afrAddress)
        } else {
          this.copyDocDetail(hblDoc)
        }
      }
    },
    async getMainHbl(isCreate) {
      return await this.getCargoDoc(this.cargoDocType.HBL, isCreate)
    },
    // 根据类型获取CargoDoc
    async getCargoDoc(docType, create = false) {
      const job = { uuid: this.cargoDoc.jobUuid }
      const cargoDocs = await new Job(job).getCargoDoc()
      if (cargoDocs == null && !create) {
        return null
      }
      for (const cargoDoc of cargoDocs) {
        if (cargoDoc.docType === docType) {
          return cargoDoc
        }
      }
      if (!create) {
        return null
      }
      if (!this.cargoDoc.job) {
        this.cargoDoc.job = await getJobByUuid(this.cargoDoc.jobUuid).then(res => res.data)
      }
      return this.newCargoDoc(this.cargoDoc.job, docType)
    },
    // 抄录HBL
    newCargoDoc(job, docType) {
      const cargoDoc = {}
      cargoDoc.job = job
      cargoDoc.docType = docType
      cargoDoc.mark = job.mark
      cargoDoc.cargoEnglishName = job.cargoEnglishName
      if (docType === this.cargoDocType.MBL && cargoDoc.notifyLine1 === '' || cargoDoc.notifyLine1 === null) {
        cargoDoc.notifyLine1 = 'SAME AS CONSIGNEE'
      }
      this.copyInfoFromSeaJob(job, cargoDoc)
      return cargoDoc
    },
    // 从海上进出口作业复制信息
    copyInfoFromSeaJob(job, cargoDoc) {
      if (cargoDoc.state > 1) {
        return
      }
      let port = null
      // 提单发货地，应该是seaopinput.placeOfReceipt
      cargoDoc.dispatchingPlace = job.dispatchingPlace
      // 提单起运港
      if (job.loadingPortCode && job.loadingPortCode.length > 0) {
        port = this.getSeaport(job.loadingPortCode)
        if (port) {
          cargoDoc.loadingPort = port.englishName
        }
      }
      // 提单卸货港
      if (job.dischargingPortCode && job.dischargingPortCode.length > 0) {
        port = this.getSeaport(job.dischargingPortCode)
        if (port) {
          cargoDoc.dischargingPort = port.englishName
        }
      }
      // 提单目的港
      if (job.destinationPortCode && job.destinationPortCode.length > 0) {
        port = this.getSeaport(job.destinationPortCode)
        if (port) {
          cargoDoc.destinationPort = port.englishName
        }
      }
      if (cargoDoc.docType !== this.cargoDocType.MBL && cargoDoc.docType !== this.cargoDocType.MBL2) {
        // 提单收货地
        cargoDoc.destinationPlace = job.destinationPlace
      }

      if (cargoDoc.docType === this.cargoDocType.MBL && job.masterFlag) {
        const office = this.$store.getters.currentOffice
        if (office) {
          cargoDoc.shipperLine1 = office.seaAddressLine1
          cargoDoc.shipperLine2 = office.seaAddressLine2
          cargoDoc.shipperLine3 = office.seaAddressLine3
          cargoDoc.shipperLine4 = office.seaAddressLine4
          cargoDoc.shipperLine5 = office.seaAddressLine5
          cargoDoc.shipperLine6 = office.seaAddressLine6
        }
      }
      // 通过参数BillOfLadingSynMode同步件毛体和包装
      CargoDocUtil.changeJobSynToBillOfLading(job, cargoDoc)
      // 根据参数判断是否同步小件数包装
      const isInsidePacking = parseInt(cache.config.get('seaInsidePacking'))
      if (isInsidePacking === 1) {
        cargoDoc.insidePacking = job.insidePacking
      }
      // cargoDoc.issuerBL = 'UBI'
      ColumnUtils.customOrderFormTypeFunc(cargoDoc)
      // 新增时，如果已经选择提单方式，会重置为默认值
      if (cargoDoc.releaseType === 0) {
        const releaseType = parseInt(cache.config.get('ReleaseTypeDefaultValue'))
        if (releaseType === 1) {
          cargoDoc.releaseType = 1
          cargoDoc.blNumber = 'THREE'
        } else if (releaseType === 2) {
          cargoDoc.releaseType = 3
          cargoDoc.blNumber = 'ONE'
        }
      } else { // 重置提单份数
        if (cargoDoc.releaseType === 1) {
          cargoDoc.blNumber = 'THREE'
        } else {
          cargoDoc.blNumber = 'ONE'
        }
      }
      if (job.lob === 'SI') {
        cargoDoc.packing = job.packing
      }
      cargoDoc.state = 1
    },
    getSeaport(code) {
      const CODE_NAME = 'Seaport'
      let lookup = this.lookup[CODE_NAME]
      if (lookup === null) {
        lookup = {}
        this.lookup[CODE_NAME] = lookup
      }

      let codeMap = lookup['codeMap']
      if (!codeMap) {
        const ports = localCacheDatas[this.localCacheKeyPrefix + CODE_NAME]
        if (ports) {
          codeMap = {}
          lookup['codeMap'] = codeMap
          for (const index in ports) {
            codeMap[ports[index].code] = ports[index]
          }
        } else {
          console.error('Missing Seaport cache.')
          return null
        }
      }
      return codeMap[code]
    },
    /**
     * 单号，hbl抄录
     */
    copyDocDetail(cargoDoc) {
      const MAX_CHART = 35
      if (!cargoDoc) {
        return
      }
      const addressForm = this.addressForm
      // addressForm.shipperLine1 = this.getAfrAddressLine(cargoDoc.shipperLine1, 0)
      addressForm.shipperLine2 = this.getAfrAddressLine(cargoDoc.shipperLine1, 0)
      if (cargoDoc.shipperLine1 && cargoDoc.shipperLine1.length > MAX_CHART) {
        addressForm.shipperLine3 = this.getAfrAddressLine(cargoDoc.shipperLine1, 1) + ' ' + cargoDoc.shipperLine2
      } else {
        addressForm.shipperLine3 = cargoDoc.shipperLine2
      }
      addressForm.shipperLine4 = cargoDoc.shipperLine3
      addressForm.shipperLine5 = cargoDoc.shipperLine4

      // addressForm.consigneeLine1 = this.getAfrAddressLine(cargoDoc.consigneeLine1, 0)
      addressForm.consigneeLine2 = this.getAfrAddressLine(cargoDoc.consigneeLine1, 0)
      if (cargoDoc.consigneeLine1 && cargoDoc.consigneeLine1.length > MAX_CHART) {
        addressForm.consigneeLine3 = this.getAfrAddressLine(cargoDoc.consigneeLine1, 1) + ' ' + cargoDoc.consigneeLine2
      } else {
        addressForm.consigneeLine3 = cargoDoc.consigneeLine2
      }
      addressForm.consigneeLine4 = cargoDoc.consigneeLine3
      addressForm.consigneeLine5 = cargoDoc.consigneeLine4
      // addressForm.notifyLine1 = this.getAfrAddressLine(cargoDoc.notifyLine1, 0)
      addressForm.notifyLine2 = this.getAfrAddressLine(cargoDoc.notifyLine1, 0)
      if (cargoDoc.notifyLine1 && cargoDoc.notifyLine1.length > MAX_CHART) {
        addressForm.notifyLine3 = this.getAfrAddressLine(cargoDoc.notifyLine1, 1) + ' ' + cargoDoc.notifyLine2
      } else {
        addressForm.notifyLine3 = cargoDoc.notifyLine2
      }
      addressForm.notifyLine4 = cargoDoc.notifyLine3
      addressForm.notifyLine5 = cargoDoc.notifyLine4
      // addressForm.shipperTel = cargoDoc.shipperTel
      // addressForm.consigneeTel = cargoDoc.consigneeTel
      // addressForm.notifyTel = cargoDoc.notifyTel
    },
    // index为0时取前35个字符，非0时取第35个后的字符
    getAfrAddressLine(line, index) {
      if (!line || line.trim() === '') {
        return ''
      }
      // 最大字符长度
      const MAX_CHART = 35
      if (index === 0) {
        return line.substr(0, MAX_CHART)
      } else {
        if (line.length > MAX_CHART) {
          return line.substr(MAX_CHART, line.length)
        }
      }
      return ''
    },
    /**
     * 单号，AfrAddress抄录
     */
    copyAfrDetail(doc) {
      if (!doc) return
      const addressForm = this.addressForm
      addressForm.shipperLine1 = doc.shipperLine1
      addressForm.shipperLine2 = doc.shipperLine2
      addressForm.shipperLine3 = doc.shipperLine3
      addressForm.shipperLine4 = doc.shipperLine4
      addressForm.shipperLine5 = doc.shipperLine5
      addressForm.shipperTel = doc.shipperTel

      addressForm.consigneeLine1 = doc.consigneeLine1
      addressForm.consigneeLine2 = doc.consigneeLine2
      addressForm.consigneeLine3 = doc.consigneeLine3
      addressForm.consigneeLine4 = doc.consigneeLine4
      addressForm.consigneeLine5 = doc.consigneeLine5
      addressForm.consigneeTel = doc.consigneeTel

      addressForm.notifyLine1 = doc.notifyLine1
      addressForm.notifyLine2 = doc.notifyLine2
      addressForm.notifyLine3 = doc.notifyLine3
      addressForm.notifyLine4 = doc.notifyLine4
      addressForm.notifyLine5 = doc.notifyLine5
      addressForm.notifyTel = doc.notifyTel
    }
  }
}
</script>

<style lang='scss'>
.edi-address-format-dialog {
  .el-scrollbar__wrap{
    overflow-x: hidden;
    margin-bottom: 0 !important;
    margin-right: 0 !important;
  }
  .el-dialog__body {
    padding: 0 !important;
  }
  .el-form-item__content {
     width: 110px;
   }
  .form-item-long {
    width: 560px;
    .el-form-item__content {
      width: 520px;
      .el-input {
        width: 220px !important;
        display: inline-block;
      }
    }
  }
  .form-item-border-group {
    padding-bottom: 0 !important;
    border-width: 0 0 1px 0;
    border-style: solid;
    border-color: black;
    .form-item-group-label {
      margin-right: 8px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      border-width: 0 1px 0 0;
      border-style: solid;
      border-color: black;
      span {
        padding-right: 30px;
        width: 100px;
      }
    }
  }
}
</style>
